import api from '../../api';

export const createMessage = (params, config) => api.post('messages', params, config);

export const readConversation = (conversationId, userId, params, config) =>
  api.put(`messages/${conversationId}/${userId}/read`, params, config);

export const updateConversation = (conversationId, params, config) =>
  api.put(`conversations/${conversationId}`, params, config);

export const updateMessage = (messageId, params, config) =>
  api.put(`messages/${messageId}`, params, config);

export const createRecording = (data) => api.post('recordings', data);

export const getMessages = (params) => api.get('messages', params);

export const getChatCount = (params) => api.get('messages/count', params);
